var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./VerbalDiscussionOffline.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4f8e58c3!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VerbalDiscussionOffline.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/tabs/DiscussionTab/VerbalDiscussionOffline.vue
// module id = 1787
// module chunks = 61